/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module react/modules/merge-styles */

/**
 * @description Dynamically merges styles into a single object.
 * @param {...(undefined|Object<string,*>|Array<(undefined|Object<string,*>),*>)} args - Arguments.
 * @returns {Object<string,*>} Merged styles object.
 */
function mergeStyles() {
  var output = {};

  for (var i = 0; i < arguments.length; i++) {
    var style = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (!style) {
      continue;
    }

    if (_Array$isArray(style)) {
      if (style[0] && style[1]) {
        style = style[0];
      } else {
        continue;
      }
    }

    for (var key in style) {
      if (Object.prototype.hasOwnProperty.call(style, key)) {
        output[key] = style[key];
      }
    }
  }

  return output;
}

export { mergeStyles };